import React, { useState, useRef, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import './multiCard.scss';

const secretKeysList = ["PAT", "Token", "Anypoint Client Secret", "Anypoint Password"];

function toTitleCase(str) {
  if (!str) return '';
  
  const acronyms = ['API', 'REST', 'SOAP', 'HTTP', 'HTTPS', 'URL', 'XML', 
                    'JSON', 'SQL', 'DB', 'UI', 'UX', 'CSS', 'HTML', 'JS',
                    'ID', 'PDF', 'CSV', 'SVG', 'PNG', 'JPG', 'GIF', 'SDK',
                    'AWS', 'GCP', 'SSH', 'FTP', 'DNS', 'IP', 'TCP', 'UDP'];
  
  const parts = str.split(/([^a-zA-Z0-9]+)/);
  
  return parts
    .map(part => {
      if (!/[a-zA-Z0-9]/.test(part)) {
        return part;
      }
      
      const upperPart = part.toUpperCase();
      if (acronyms.includes(upperPart)) {
        return upperPart;
      }
      
      for (const acronym of acronyms) {
        const regex = new RegExp(acronym + '$', 'i');
        if (regex.test(part)) {
          const prefix = part.slice(0, -acronym.length);
          if (prefix) {
            return prefix.charAt(0).toUpperCase() + prefix.slice(1).toLowerCase() + acronym;
          }
          return acronym;
        }
      }
      
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
}

const MultiCard = (props) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // const handleEdit = (e) => {
  //   e.stopPropagation();
  //   setShowDropdown(false);
  //   if (props.onEdit) {
  //     props.onEdit(props.headerData, props.footerData);
  //   }
  // };

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowDropdown(false);
    if (props.onDelete) {
      props.onDelete(props.headerData, props.footerData);
    }
  };

  const handleShare = (e) => {
    e.stopPropagation();
    setShowDropdown(false);
    if (props.onShare) {
      props.onShare(props.headerData, props.footerData);
    }
  };

  // Delete shows by default; pass showDelete={false} to hide it (e.g. non-owners).
  const showDelete = props.showDelete !== false;
  const showShare = !!props.onShare;
  const hasMenu = showDelete || showShare;

  if (!props.headerData || !props.footerData) {
    return null;
  }

  return (
    <div className={`cardContainer ${props.theme} ${props.cardType || ''}`} onClick={props.onClick}>
      {/* Three-dot menu */}
      {hasMenu && (
      <div className="card-actions-menu" ref={dropdownRef}>
        <button
          className="three-dot-btn-card"
          onClick={(e) => {
            e.stopPropagation();
            setShowDropdown(!showDropdown);
          }}
        >
          ⋮
        </button>

        {showDropdown && (
          <div className="dropdown-menu-card">
            {showShare && (
              <button className="dropdown-item-card" onClick={handleShare}>
                <span className="icon">🔗</span> Share
              </button>
            )}
            {showDelete && (
              <button className="dropdown-item-card delete" onClick={handleDelete}>
                <span className="icon">🗑️</span> Delete
              </button>
            )}
          </div>
        )}
      </div>
      )}

      {props.cardType !== "grid" ? (
        <>
          {/* Regular Card Header */}
          {Object.entries(props.headerData).map(([key, value]) => (
            <div className='cardHeader' key={key}>
              <span className='headerTitle'>{key}</span>
              <span className='headerValue'>{toTitleCase(value)}</span>
            </div>
          ))}
          
          {/* Regular Card Footer */}
          {Object.entries(props.footerData).map(([key, value]) => (
            <div className='cardFooter' key={key}>
              <span className='footerTitle'>{key}</span>
              <span className='footerValue'>
                {secretKeysList.includes(key) ? (
                  <input className="table-apssword" type="password" value={value} readOnly />
                ) : (
                  <span>{value}</span>
                )}
              </span>
            </div>
          ))}
        </>
      ) : (
        <>
          {/* Grid Card Header */}
          <Row className="gridCardHeader">
            {Object.entries(props.headerData).map(([key, value]) => (
              <Col xs={6} key={key}>
                <span className='headerTitle'>{key}</span>
                <span className='headerValue'>
                  {secretKeysList.includes(key) ? (
                    <input className="table-apssword" type="password" value={value} readOnly />
                  ) : (
                    value
                  )}
                </span>
              </Col>
            ))}
          </Row>
          
          {/* Grid Card Footer */}
          <Row className='gridCardFooter'>
            {Object.entries(props.footerData).map(([key, value]) => (
              <Col xs={6} key={key}>
                <div className='cardFooter'>
                  <span className='footerTitle'>{key}</span>
                  <span className='footerValue'>
                    {secretKeysList.includes(key) ? (
                      <input className="table-apssword" type="password" value={value} readOnly />
                    ) : (
                      <span>{value}</span>
                    )}
                  </span>
                </div>
              </Col>
            ))}
          </Row>
        </>
      )}
    </div>
  );
};

export default MultiCard;